import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from '../store'
import 'nprogress/nprogress.css'
import {startLoading, closeLoading, getAsyncRouters} from '../authority/routerAuthority'

Vue.use(Router)

/* 加载进度 */
NProgress.configure({
  speed: 500,
  showSpinner: false
})

const errorRoutes = [
  {
    name: 'Error',
    path: '/error/:message',
    props: true,
    component: resolve => require(['../pages/constant/error'], resolve)
  }
]

const router = new Router()

function resetRouter () {
  const newRouter = new Router()
  router.matcher = newRouter.matcher
}

function addAsyncRoutes (isReset = false) {
  startLoading()
  Vue.prototype.$ajax({
    url: '/ws/student/studentHome/queryMenuData',
    method: 'post'
  }).then(response => {
    if (response.data && response.data.errorCode === 0) {
      store.commit('setProfile', response.data.profile || {})
      // 动态添加路由
      router.addRoutes(getAsyncRouters(response.data.menuList || []))
      if (isReset) {
        router.push('/home')
      }
      // 添加路由监听
      router.beforeEach((to, from, next) => {
        NProgress.start()
        if (!to.matched || to.matched.length === 0) {
          next('/')
        } else {
          next()
        }
      })
      router.afterEach((to, from) => {
        NProgress.done()
      })
    } else {
      // 显示失败页面
      router.addRoutes(errorRoutes)
      router.push(`/error/${response.data.message || '获取页面权限信息失败'}`)
    }
  }, () => {
    router.addRoutes(errorRoutes)
    router.push(`/error/请求获取页面权限信息失败`)
  }).finally(() => {
    closeLoading()
  })
}

export {
  router,
  resetRouter,
  addAsyncRoutes
}
